export const palette = {
    dark: "#212529",
    purple_dark: "#4F3D7F",
    purple_deep: "#9384D1",
    purple: "#C9A7EB",
    purple_light: "#ECC9EE",
    white: "#EEE2DC",
    grey: "#EEEEEE",
    cream: "#EDC7B7"
};